import { ReactNode } from 'react';
import { Text } from '~/components/ui/Text';
import {
	StyledInfoItem,
	StyledInfoItemShadow,
	StyledInfoItemTitle,
	StyledInfoItemValue,
	StyledItemBottomContainer,
} from './AppMyBusinessStatItem.styled';

interface AppMyBusinessStatItemProps {
	title: string;
	valueIcon: ReactNode;
	valueText: string;
	valueSubText?: string;
	children: ReactNode;
}

const AppMyBusinessStatItem = ({
	title,
	valueIcon,
	valueText,
	valueSubText,
	children,
}: AppMyBusinessStatItemProps) => {
	return (
		<StyledInfoItem>
			<StyledInfoItemShadow />
			<StyledInfoItemTitle>{title}</StyledInfoItemTitle>
			<StyledInfoItemValue>
				{valueIcon}
				<Text>
					{valueText} {valueSubText && <span>{valueSubText}</span>}
				</Text>
			</StyledInfoItemValue>
			<StyledItemBottomContainer>{children}</StyledItemBottomContainer>
		</StyledInfoItem>
	);
};

export { AppMyBusinessStatItem };
